import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/node/app/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const PageDescription = makeShortcode("PageDescription");
const ListBadges = makeShortcode("ListBadges");
const AnchorLinks = makeShortcode("AnchorLinks");
const AnchorLink = makeShortcode("AnchorLink");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const ImageGallery = makeShortcode("ImageGallery");
const ImageGalleryImage = makeShortcode("ImageGalleryImage");
const ResourceCard = makeShortcode("ResourceCard");
const ArticleCard = makeShortcode("ArticleCard");
const ImageCard = makeShortcode("ImageCard");
const Caption = makeShortcode("Caption");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <PageDescription mdxType="PageDescription">
      <p>{`Analysis. Coding. But also… finding the `}<strong parentName="p">{`story`}</strong>{` the data hides. What happens when you let a novelist loose on the data with expert tools like Pandas and Numpy, plus a self-help writer’s knack for explanation?`}</p>
      <p>{`Get ready to level up.`}</p>
    </PageDescription>
    <ListBadges frontmatter={props.pageContext.frontmatter} mdxType="ListBadges" />
    <AnchorLinks mdxType="AnchorLinks">
  <AnchorLink mdxType="AnchorLink">Certification: MicroMasters in Data Science from UC San Diego</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Reports (Jupyter Notebooks)</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Data Science Projects</AnchorLink>
  <AnchorLink mdxType="AnchorLink">Why Work With Bill?</AnchorLink>
    </AnchorLinks>
    <h2>{`Certification: MicroMasters in Data Science from UC San Diego`}</h2>
    <a name="certification" />
    <div className="list-badges">
      <img {...{
        "src": "https://img.shields.io/badge/edX-%2302262B.svg?style=for-the-badge&logo=edX&logoColor=white",
        "alt": "edX"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/python-3670A0?style=for-the-badge&logo=python&logoColor=ffdd54",
        "alt": "Python"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/jupyter-%23FA0F00.svg?style=for-the-badge&logo=jupyter&logoColor=white",
        "alt": "Jupyter Notebook"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/pandas-%23150458.svg?style=for-the-badge&logo=pandas&logoColor=white",
        "alt": "Pandas"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/numpy-%23013243.svg?style=for-the-badge&logo=numpy&logoColor=white",
        "alt": "NumPy"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/Matplotlib-%23ffffff.svg?style=for-the-badge&logo=Matplotlib&logoColor=black",
        "alt": "Matplotlib"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/scikit--learn-%23F7931E.svg?style=for-the-badge&logo=scikit-learn&logoColor=white",
        "alt": "scikit-learn"
      }}></img>
    </div>
    <Row mdxType="Row">
  <Column colMd={8} colLg={8} mdxType="Column">
        <ImageGallery mdxType="ImageGallery">
          <ImageGalleryImage alt="MicroMasters Certificate in Data Science from UC San Diego" title="MicroMasters Certificate in Data Science from UC San Diego" mdxType="ImageGalleryImage">
            <span {...{
              "className": "gatsby-resp-image-wrapper",
              "style": {
                "position": "relative",
                "display": "block",
                "marginLeft": "auto",
                "marginRight": "auto",
                "maxWidth": "1152px"
              }
            }}>{`
      `}<span parentName="span" {...{
                "className": "gatsby-resp-image-background-image",
                "style": {
                  "paddingBottom": "83.68055555555556%",
                  "position": "relative",
                  "bottom": "0",
                  "left": "0",
                  "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAIAAABSJhvpAAAACXBIWXMAAAsTAAALEwEAmpwYAAAByElEQVQ4y41TbW/TMBjM//9X8DEUNHVo6cqoWpV0LFtebMd+Xm2jJK1AQKc+OvlTzr6751IwYQje+3EcXQieCYXpGog5AAXAABhTKgDCx7Is7+6q7XZ/PPIVGhNGFWPd/lAfjqfd/gciFcKkwsKUokYVuf6yCuecc0rCLCI55QKCr6qH3fenx01lzZCiqvBfmAQjEFFKiYjruj4ejyJSBD+uVp++3q+/fF49n06E4Ef3JyB4YUIIRMjMIQQA8N6rasGEzpqh75w1r83Ly89nZ83orLNmgR/dkmKKMedsrV2v1/v9PqVUIIRNVW2qh2/bLUJYdMaL4KgyBbFkxkzzjOPYNM0kmwn7ru26tu/aoe/6rjVDv5zOmktaKHNaMUbC6RYAiDEW72z1NwhVZE46ERIEeGveJs83kmOMKSVE9N4759q2nWTfQmbClFK+DABYa6fAbnqZz4YREQD6vm+ahplvIeO5W7NnVfXeG2POngnh/f9BVRemiKiqtbaua6K525Mk1WWr+u+GCZd65JxFBACWbU+ek+qHsnzc7SD4oe9HZ72zIXhjBjMMAIHn7/L/psg5l+v7p8OB5+oswkTEuami3nsiylfmF3ma1uIIaY4rAAAAAElFTkSuQmCC')",
                  "backgroundSize": "cover",
                  "display": "block"
                }
              }}></span>{`
  `}<img parentName="span" {...{
                "className": "gatsby-resp-image-image",
                "alt": "MicroMasters Certificate",
                "title": "MicroMasters Certificate",
                "src": "/static/98439350edcbfd4594ec111e6d7efc57/3cbba/bill-powell-micromasters-data-science.png",
                "srcSet": ["/static/98439350edcbfd4594ec111e6d7efc57/7fc1e/bill-powell-micromasters-data-science.png 288w", "/static/98439350edcbfd4594ec111e6d7efc57/a5df1/bill-powell-micromasters-data-science.png 576w", "/static/98439350edcbfd4594ec111e6d7efc57/3cbba/bill-powell-micromasters-data-science.png 1152w", "/static/98439350edcbfd4594ec111e6d7efc57/aee90/bill-powell-micromasters-data-science.png 1534w"],
                "sizes": "(max-width: 1152px) 100vw, 1152px",
                "style": {
                  "width": "100%",
                  "height": "100%",
                  "margin": "0",
                  "verticalAlign": "middle",
                  "position": "absolute",
                  "top": "0",
                  "left": "0"
                },
                "loading": "lazy",
                "decoding": "async"
              }}></img>{`
    `}</span>
          </ImageGalleryImage>
        </ImageGallery>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard aspectRatio="1:1" title="To earn this certificate from the University of California San Diego, I completed four graduate-level courses in data science. I got all As." href="https://data.billalive.com/certification" mdxType="ResourceCard">
        </ResourceCard>
  </Column>
    </Row>
    <h2>{`Reports (Jupyter Notebooks)`}</h2>
    <p>{`I’ve published `}<a parentName="p" {...{
        "href": "https://data.billalive.com"
      }}>{`several reports`}</a>{` as Jupyter notebooks, each of which explores a complex question using an official dataset.`}</p>
    <div className="list-badges">
      <img {...{
        "src": "https://img.shields.io/badge/jupyter-%23FA0F00.svg?style=for-the-badge&logo=jupyter&logoColor=white",
        "alt": "Jupyter Notebook"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/r-%23276DC3.svg?style=for-the-badge&logo=r&logoColor=white",
        "alt": "R"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/python-3670A0?style=for-the-badge&logo=python&logoColor=ffdd54",
        "alt": "Python"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/pandas-%23150458.svg?style=for-the-badge&logo=pandas&logoColor=white",
        "alt": "Pandas"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/numpy-%23013243.svg?style=for-the-badge&logo=numpy&logoColor=white",
        "alt": "NumPy"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/Matplotlib-%23ffffff.svg?style=for-the-badge&logo=Matplotlib&logoColor=black",
        "alt": "Matplotlib"
      }}></img>
      <img {...{
        "src": "https://img.shields.io/badge/scikit--learn-%23F7931E.svg?style=for-the-badge&logo=scikit-learn&logoColor=white",
        "alt": "scikit-learn"
      }}></img>
    </div>
    <Row mdxType="Row">
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard subTitle="Your Real Odds of Dying From COVID-19" author="Bill Alive" href="https://data.billalive.com/21b18-covid-risks/" date="Updated: 2022 Sep 21" readTime="Read time: 25 min" actionIcon="launch" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "780px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACVUlEQVQ4y6WU22rcMBCG9/0fIoTc5rrQQtub0oRCYUPXWR9lWba1K1u2LB90tDdb1s5u2ty0IR9zMTD8MDP6Navj8Xg4HJ5mjm9kdXwHq67rHh4eIISu6/q+fzgc3iA2xhRF0c90XaeUMsZorc2MlFIppbW21l6ScRyVUtbalRBDlmV5nqdpmiQJhHDJEUJxHGOMEUIAgHQmDEMAQBzHlFIp5cqO0zAMTdP0fS+EkFIOwyClFEJ0XWet1TNLR+0M53zZ7qqVI+/6rm2rqhJCXOZZytPfPJ2x1k7TdNr2OI6UUs55Xdecc8ZY27aMMUqpMeYfT2WM8X0fQhhF0TJYHMdJknieVxRFOzdV1zWdWfKlx5NYaw0AIIQsCx/OJEkCAAjDEELY/AFjTCn1LBZCrNdrz3V50/C52DDGOY+iaDvjbDaPjvPoOM5m47ouIURr/SxWWoM4zjEuKBXzWpUx2tp9UcAkiVMUplmUnSJAqKoqY8w4jmcxa9YfPv36+Hl//9P68ejHxgNTmOTff3jf7vMvX+urq/rmhl1fs9vbvmmElNba88xS+htnBxPV8KGqe1pJ1mjeVXgXui7abNK7u8ZxLIQGISVOvIiVUhEAQRTmGJOyzDCWWttpqpsmSVEYxwkhYppOMY6Lf17EUsrtdhv4/m63KwihZZlnWV1VrK4hhGEQlIQoIeQwyGEQQgzD8FqMEKKUlmVZzLRtW5al53lBEDDGFs1C3/eLeZ5NkqYpxnixAcaYEDJNJ8/neb7f75fPdMEYM03T62NwOSb/eVXedUl+A+RdbCky+xAuAAAAAElFTkSuQmCC')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Chart",
              "title": "Chart",
              "src": "/static/b10258ba5ec2d6a2afc7dff32d3d9a24/fc794/covid-deaths-ages-40-49.png",
              "srcSet": ["/static/b10258ba5ec2d6a2afc7dff32d3d9a24/7fc1e/covid-deaths-ages-40-49.png 288w", "/static/b10258ba5ec2d6a2afc7dff32d3d9a24/a5df1/covid-deaths-ages-40-49.png 576w", "/static/b10258ba5ec2d6a2afc7dff32d3d9a24/fc794/covid-deaths-ages-40-49.png 780w"],
              "sizes": "(max-width: 780px) 100vw, 780px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard subTitle="Does Diabetes Correlate With Affluence?" author="Bill Alive" href="https://data.billalive.com/22715-diabetes-correlate-affluence/" date="Updated: 2022 Sep 15" readTime="Read time: 15 min" actionIcon="launch" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "700px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAAsTAAALEwEAmpwYAAADBElEQVQ4y22Ua4+bOBSG5///kvZDZ9RKo2q7q5lkM2kyJOmEhIZLuIRLCBgwYIMxN3ubUE02Ut8vFvb76Jzz2uKO/0nNRcfjURAESZK6riuKwrbtPM/DMMzznHPOGLsbFl3XJUnSNG273RJCLMv656KXl5fJZEIpbZrm8fFxPB4/PDxMp9MbuK7rwUEp7fu+LIoIAF3XX+fz79MpqQjnXFVVWZZFUVQUZWjwjjHGOUcIBUEQxzEAoK7r4axnrLscM87+ON3dMKHv+/v9frVczgUhNKxGt4lm1rqNZD1eSygCRUEwxmmank6nMAyvML2oqqqNuJEUJZdU/te0//ad/z2LH745n74azhpWGSVVFEW6rluWdYWHsTnnGCHNNKjp8OcF+3fJR4v8eZaF8BO6NxvzbCiw53lD2r9hCKEgCNvt9qckvW02yVbhowUbLfizAJ9muqFL2U9cYlpRCKFhGI7jXOGu66qqAgAosry3TKwY/Flg4wV/EtLR3D16y2JJW8p6lqPcsqzT6XSFCSEIIQDARhQlRUZneDHAcPbDtO01WldN1Xd9lmemafq+f4WjKBIEYb/fa6q201Sk6O+Vk418OLo2suvq/BCyLHMcBwAwZHQTGEySnaZi9b3ya7LT7JO3I7vBVpal67pBENwEJoqiqqqapmmmke3217Z1y3TtEAesYoyyPMsdx7lpu67rOI6zLIsAWK7ffsOXtNOD63r+JJt8zD7eo/sjPHqOF4L/PZKh577vYQKNw6HQrPPMowUfLzLPDwLwOfv8If3wBX3xoX90jwCAm8qEkDRN57P5j42YbOQz/PTKJ6vIdnXTWOWrpmo45TCBmqbd3PN78SRO5L1W6gc+XrLxik/fUAA836dd1fO+4x3jDACQJMkV7vu+bduu6yilZVk2JWlz3Oaow2Vb103TDIa2bfu+b5qmbdsrjDEGAERRBCGM4ziK4zhNwyiKUxgCcPlKo4uSJAnDkBBy/RlQSvFFZVlijIuiKMuyKIphpyhLhNC7gRAyzPir8n9zWE59+DeYsAAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Chart",
              "title": "Chart",
              "src": "/static/a0b2aab76765ad018e3a09ec7a635d8b/f847a/diabetes-correlate-affluence.png",
              "srcSet": ["/static/a0b2aab76765ad018e3a09ec7a635d8b/7fc1e/diabetes-correlate-affluence.png 288w", "/static/a0b2aab76765ad018e3a09ec7a635d8b/a5df1/diabetes-correlate-affluence.png 576w", "/static/a0b2aab76765ad018e3a09ec7a635d8b/f847a/diabetes-correlate-affluence.png 700w"],
              "sizes": "(max-width: 700px) 100vw, 700px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
  <Column colMd={4} colLg={4} mdxType="Column">
        <ArticleCard subTitle="Do Countries Have “Synthetic” Traits?" author="Bill Alive" href="https://data.billalive.com/22719-country-synthetic-traits/" date="Updated: 2022 Sep 13" readTime="Read time: 25 min" actionIcon="launch" mdxType="ArticleCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1003px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAIAAAAC64paAAAACXBIWXMAAA7EAAAOxAGVKw4bAAACn0lEQVQ4y4VUy0ocQRSdL3HlQgRBFEUFXehKwY2CuBBciO78Aj8iG90kRHAnCAlxkdEPcJFIFkkIRMSFznT1o7rr1dXV3dX1CN01mTE4ksPty6WqDudUVd9qcc4JIYwxjDEZAKec2/+hFccJ8P16eQNGGaX1xxkr89xFkdcQQuQ9FEJkQogWYyxJEkIIpZQQCjzf80DsR8T3YwCSJqIw6Dx1AfC7XrfreY+PTxGMOOet5zaMMWEYQgiTJImTJIyiBCEYx1VWFbSQQpa8tLmRqTTK1LbNX5RlyTmXUpbPUMmKZvTq7qr9u319d3356/Lix8X59/ObhxtZylZfEwBACHF1f9Ba26Gd6bfT4yfjI29GVs5WDj8f7nzYOf12airTUkqVZSmlDMOQUvqS7DFv4f3C8tny7sfd9n3bWquNVkrled4SQgRBkCSJ53lpmr4k+wzMvJvZ+7RXj1ijjNJGV6oqiqJnW2vd7XaHK2fh2MnY/uW+03RTPWV3WgihIcpK2fsH+PPL5vnm8dfj51M9srW2KAoIYRAEA2W3CGM7O2vX1qyUzkn/UgdkZxsAMFDWjb3bWzsxYdfXbVkOJ+sGCKEBmRAbhpZze3RkR0ftxsar5DzP4ziOosj3fc65xdhsb9uxMTs1ZScn62J19VWytZZSGoWhHwQUIXtwoOfm9NKSWVzUS0t6fl5vbek8N83WjDEuV1U12LM7RkopDgLs+wzCBIBejuMsyxBCjDGXMcYIoboxlFJVVUkplVL1j11V/TBmYNQJuoF+O9QtCSEMGwRBHZ7nBcBPICyFkEWDvCj+LaoGLQhhp0GaplkmMi44z0ouVJaVjBVpylhKMWWMuYZ3hWuH+rTTNI2iyL0HmGBKKcKYNJkyRgjRWg99hv4AOP1JNlTehbEAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Chart",
              "title": "Chart",
              "src": "/static/ab74c8c32b0ea6f20c97a0de842e8638/a9c44/countries-synthetic-traits-chart1.png",
              "srcSet": ["/static/ab74c8c32b0ea6f20c97a0de842e8638/7fc1e/countries-synthetic-traits-chart1.png 288w", "/static/ab74c8c32b0ea6f20c97a0de842e8638/a5df1/countries-synthetic-traits-chart1.png 576w", "/static/ab74c8c32b0ea6f20c97a0de842e8638/a9c44/countries-synthetic-traits-chart1.png 1003w"],
              "sizes": "(max-width: 1003px) 100vw, 1003px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ArticleCard>
  </Column>
    </Row>
    <h2>{`Data Science Projects`}</h2>
    <h3>{`The Vaccine Show!`}</h3>
    <Row mdxType="Row">
  <Column colMd={8} colLg={8} mdxType="Column">
    <ImageCard hoverColor="light" titleColor="light" subTitleColor="light" iconColor="light" actionIcon="launch" aspectRatio="2:1" href="/" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1104px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAACaElEQVQoz2OQ5DCT4DBT5rHxVvAy5Y7VZ4x14E3xFs5wE6jMlZ/carCpWLEzWqbWnrnKhCtGiyPQU8FLW8hGnN1cksOMQZLTVJTFRpbDMVU5P15gcbztFF+VthCDDm+LKWl2y+cVHe7ynxyjPS3RZpqzcp4H86Q0qXolXhshBmuQZgEmi1wL3X5TnQB+x8lm7ttzsqP1versvOdnJJd5RG8sDV0QZj0nwH1tbnS7pdtCN492S5saI7f2IH0xFjMGETYLH3nTPX4yRz0Vr4aK3cmQWGUptC9AcoGVypFQsTVOipvspW5nSl7LkLoUJnK/RPZxnPR03eBwfRtJNlMGaU5TGVbPBg23mzlKp/ylTyapnwuTPR6pvMVLY5+3zPYI3X1ucudTlY75yFwp0rlRpHEvVzlHxk2G1UeKw5RBlNXUXtY9QjS2xjJgoZ3t9QSZSz6SB+wkjgbJ73eXfVCufjlW9mKI9OUIxfPhEsej9SY5eSbIJrjLBYqxmTJIcphJs9nq83l5i9cvsPf4WK9yO13mTLzCuXTls5kq3ZoqNyvVrmUp3C1UvpkmtS/QME6y3EgwSJrNChRg4uxmKnzmLXbhPmzTi2RsLmVpHk60Wuagu8JZc6ub7PEE9c1eGociDTb5mp5P1Jqrp+7P1t1uk2UsaSzCYs4AiWdb0SBjvvAEubxk2Yl+mjW+2m1hJpWBusXZXvUVUb1emuX+evnRcu0lSp2m/KHWwmFyPCYS7GYgzSD9rHZmovYLwn0tOVMt2DNdhLL9JHNDRZrDJVp8RUrNOVMseCP0WRKn+oUEqDuLMTlKcYJ0AQBSMLhkP4p/uwAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "The Vaccine Show",
              "title": "The Vaccine Show",
              "src": "/static/dbbd30897d9518fb40bbdf0178cc4717/242c1/vaccine_show_featured.png",
              "srcSet": ["/static/dbbd30897d9518fb40bbdf0178cc4717/7fc1e/vaccine_show_featured.png 288w", "/static/dbbd30897d9518fb40bbdf0178cc4717/a5df1/vaccine_show_featured.png 576w", "/static/dbbd30897d9518fb40bbdf0178cc4717/242c1/vaccine_show_featured.png 1104w"],
              "sizes": "(max-width: 1104px) 100vw, 1104px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ImageCard>
        <Caption fullWidth mdxType="Caption">
For the motivation and data analysis behind this game, see <a href="https://data.billalive.com/21b18-covid-risks/">"Your Real Odds of Dying from COVID-19"</a>.
        </Caption>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard aspectRatio="1:1" title="Explore the hard data of COVID-19 risks and the case for vaccines in a quirky, nonjudgmental game." href="https://vaccineshow.billalive.com" mdxType="ResourceCard">
          <img {...{
            "src": "https://img.shields.io/badge/r-%23276DC3.svg?style=for-the-badge&logo=r&logoColor=white",
            "alt": "R"
          }}></img>
        </ResourceCard>
  </Column>
    </Row>
    <h3>{`Yarm: Yet Another Report Maker`}</h3>
    <Row mdxType="Row">
  <Column colMd={8} colLg={8} mdxType="Column">
        <ImageCard hoverColor="light" titleColor="light" subTitleColor="light" iconColor="light" actionIcon="launch" aspectRatio="2:1" href="/" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "1152px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "50%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAIAAAA7N+mxAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB60lEQVQoz2OQkJGVkJGVkgWRkrJgBOZKyUK5UkhIUgahTEJGlkFCRlZcRpZPQlpCRlZQQlpYUkZIUoZbVJpHVIpfXFpQUoZHXJpbXJpfAoREpGUkZWX5JaVFpGQkZWQZxKVlZeXk/EzUxaRkXMzVLPSVbQ1Usrz1Mjz1vC3U7XRU0ux1shx0A03V/Y01NZQVBSRkfAzUTdWVhaVkGESkZZUV5D6X2fobqsxOMtpVbLYp2/Rhm+2XCY6HSiz2J5n9qHd4Xm1X6q5zNcf2Vq7NulDDf6UOmdaaXOLSDGLSsvJycpMCdRv8tO82W67JM07x0FhfZHSzw/JQtemFcvOmAG0BCWl5BdnLxWaPqyzvVVi+qrXKdtLgEpNmgAQAh6i0jYHSk8k2O+rMbs+1uTzF6sEcmxN9Ftf6rGoidBj5pZSV5J9Psy0M1NJQlX8wybo4SJtDWJpBSlZWUFImzl79Rqvlk6nW0S7qUwsN7y+3fbLKbmuH2Yl+i7JIHQ4haQlp2fUNJmkBmgzcknMLDXOCtTiFwDaLS8tqqMhrqSrIy8sJisuISctqqitoqCkoKsmpKMvLKciJy8iKSYOiSk5BTkwapF5WXk5cGhxVEjKyolIyIlIgbZAIFJUCITFpKAlRIw7WJgljQ+OZbAQApqiAAUEmrEUAAAAASUVORK5CYII=')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Yarm",
              "title": "Yarm",
              "src": "/static/0df721ce52fbe6491d8c6ca92d6a116b/3cbba/yarm_featured.png",
              "srcSet": ["/static/0df721ce52fbe6491d8c6ca92d6a116b/7fc1e/yarm_featured.png 288w", "/static/0df721ce52fbe6491d8c6ca92d6a116b/a5df1/yarm_featured.png 576w", "/static/0df721ce52fbe6491d8c6ca92d6a116b/3cbba/yarm_featured.png 1152w", "/static/0df721ce52fbe6491d8c6ca92d6a116b/0b124/yarm_featured.png 1728w", "/static/0df721ce52fbe6491d8c6ca92d6a116b/59ab2/yarm_featured.png 1800w"],
              "sizes": "(max-width: 1152px) 100vw, 1152px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ImageCard>
        <Caption fullWidth mdxType="Caption">
Yarm is available on <a href="https://pypi.org/project/yarm/">PyPI</a> and <a href="https://yarm.readthedocs.io/">fully documented</a>.
        </Caption>
  </Column>
  <Column colMd={4} colLg={4} noGutterSm mdxType="Column">
        <ResourceCard aspectRatio="1:1" title="Create reports easily by running SQL queries on spreadsheets and CSVs, and configure it all in YAML." href="https://yarm.readthedocs.io/" mdxType="ResourceCard">
          <img {...{
            "src": "https://img.shields.io/badge/python-3670A0?style=for-the-badge&logo=python&logoColor=ffdd54",
            "alt": "Python"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/pandas-%23150458.svg?style=for-the-badge&logo=pandas&logoColor=white",
            "alt": "Pandas"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/numpy-%23013243.svg?style=for-the-badge&logo=numpy&logoColor=white",
            "alt": "NumPy"
          }}></img>
        </ResourceCard>
  </Column>
    </Row>
    <h3>{`Millennium of Music`}</h3>
    <Row mdxType="Row">
  <Column colMd={4} colLg={4} mdxType="Column">
    <ImageCard hoverColor="light" titleColor="light" subTitleColor="light" iconColor="light" aspectRatio="1:1" mdxType="ImageCard">
          <span {...{
            "className": "gatsby-resp-image-wrapper",
            "style": {
              "position": "relative",
              "display": "block",
              "marginLeft": "auto",
              "marginRight": "auto",
              "maxWidth": "264px"
            }
          }}>{`
      `}<span parentName="span" {...{
              "className": "gatsby-resp-image-background-image",
              "style": {
                "paddingBottom": "100%",
                "position": "relative",
                "bottom": "0",
                "left": "0",
                "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAUCAYAAACNiR0NAAAACXBIWXMAAAsTAAALEwEAmpwYAAAB80lEQVQ4y91US3MSYRDcv+EhyMLyiM0ShBTBJAUGjDxCSAggRJQQYx5l1CoPPqu8+6/bamZXN2UoPXiwPEx9uzP9zaN7Z510Bvyb5vz7CVPp34OimGXPNzpUIGrLkkV9y/yOlwIzWTCbBVdX7VQgmTJT7Laul/mdfA68HIIfZuBZHzzugKMWePgIHDy25PEEmPCswIoLbpfBSgmMJcwXxhYdKlDfBF8eWcLzI/CkB0674LOuJVVM/ukeeDEAn+6B8wNw1DSsfLOeTbgQZaMIng/AF33w7THYa1jXVyPwy6ldfvUEvBraKdy7Kfh5bu/Cnh6CBR901Gp3x0BbZRu3WQUnbXDSAffrNkFjCzxoWKxds+5Ej+62qmDnIZj3A5XdJBhzwaQHrsRNGBXSuX4fFM8y4eKB3YmZCK4H3k1YzEsHI2cChZQgB6su4sdt8OsZ+PHEeBw2ragwvTrY3wWLayDu3bIpAmqk9zPjsZAHy0WwVTPSxZEEeD02vsWfhHi+D5YKdv+XhFLyemwka+Q1H3wzsUQSQV1+u7aiIe7THPRzoL7nGwn1LVUrJoyIFkAdquuNEvhgHdzdNoFqFetKtrMJ+ogkjK6RyA7FWHSdMrFUTBYK4iZ/blI8EOPH6i1b+vA9E123iEV90fvOn/xV/q8f7HfhAW7+j7yUXgAAAABJRU5ErkJggg==')",
                "backgroundSize": "cover",
                "display": "block"
              }
            }}></span>{`
  `}<img parentName="span" {...{
              "className": "gatsby-resp-image-image",
              "alt": "Millennium of Music",
              "title": "Millennium of Music",
              "src": "/static/dc60ce0d72089bc7071f0ef4524b8193/8944f/millmusic-logo.png",
              "srcSet": ["/static/dc60ce0d72089bc7071f0ef4524b8193/8944f/millmusic-logo.png 264w"],
              "sizes": "(max-width: 264px) 100vw, 264px",
              "style": {
                "width": "100%",
                "height": "100%",
                "margin": "0",
                "verticalAlign": "middle",
                "position": "absolute",
                "top": "0",
                "left": "0"
              },
              "loading": "lazy",
              "decoding": "async"
            }}></img>{`
    `}</span>
        </ImageCard>
  </Column>
  <Column colMd={8} colLg={8} noGutterSm mdxType="Column">
        <ResourceCard aspectRatio="2:1" actionIcon="disabled" subTitle="(Forthcoming)" title="How do you keep hundreds of member subscriptions in sync and up-to-date between a WordPress site and your payment processor? This Jupyter notebook walks you step-by-step through a complex recurring monthly report." mdxType="ResourceCard">
          <img {...{
            "src": "https://img.shields.io/badge/python-3670A0?style=for-the-badge&logo=python&logoColor=ffdd54",
            "alt": "Python"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/pandas-%23150458.svg?style=for-the-badge&logo=pandas&logoColor=white",
            "alt": "Pandas"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/numpy-%23013243.svg?style=for-the-badge&logo=numpy&logoColor=white",
            "alt": "NumPy"
          }}></img>
          <img {...{
            "src": "https://img.shields.io/badge/jupyter-%23FA0F00.svg?style=for-the-badge&logo=jupyter&logoColor=white",
            "alt": "Jupyter Notebook"
          }}></img>
        </ResourceCard>
        <Caption fullWidth mdxType="Caption">
A forthcoming report based on my work managing member subscriptions for <a href="https://millenniumofmusic.com">Millennium of Music</a>, a classical music non-profit.
        </Caption>
  </Column>
    </Row>
    <h2>{`Why Work With Bill?`}</h2>
    <p>{`Data science lets me bring all my major skills to the table:`}</p>
    <ul>
      <li parentName="ul">{`elegant `}<strong parentName="li">{`coding`}</strong></li>
      <li parentName="ul">{`intense `}<strong parentName="li">{`intellectual analysis`}</strong></li>
      <li parentName="ul">{`finding the `}<strong parentName="li">{`compelling stories`}</strong>{` in the data`}</li>
      <li parentName="ul">{`and making `}<strong parentName="li">{`complex topics understandable`}</strong>{` to non-experts`}</li>
    </ul>
    <p>{`To learn more about my journey into data science, read `}<a parentName="p" {...{
        "href": "/about/"
      }}>{`my story`}</a>{`.`}</p>
    <p>{`To keep exploring how my combination of skills can help you, continue on to `}<a parentName="p" {...{
        "href": "/code/"
      }}>{`Code`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      